import React from 'react';
import { ADMIN_PARTNERS_DETAILS_PATH } from '../../../constants/routes';
import CategoryVisibilitySelector from '../../admin/forms/CategoryVisibilitySelector';

const SetVisibleCategoriesInputs = ({ staticData = {}, data, onInput, dependencies = {} }) => {
    const categories = dependencies.categories || [];
    const partner = staticData.partner || {};
    const selectedCategories = data.categoryIds || [];

    const handleCategoryChange = updatedCategories => {
        onInput(updatedCategories, 'categoryIds');
    };

    const partnerDetailsUrl = ADMIN_PARTNERS_DETAILS_PATH.replace(':partnerId', partner.id);

    return (
        <React.Fragment>
            <p className="u-margin-bottom-2">
                Select the categories that should be visible to <span className="u-bold">{partner.name}</span> for this
                event.
            </p>
            <div className="ckp-admin-grid-column">
                <CategoryVisibilitySelector
                    categories={categories}
                    selectedCategories={selectedCategories}
                    onChange={handleCategoryChange}
                    label="Visible Categories"
                />
            </div>
            <div className="ckp-admin-modal-forms-footer-link">
                <a
                    href={partnerDetailsUrl}
                    className="ckp-buttons-text"
                    style={{ padding: '0', transform: 'translateY(60px)' }} // Not ideal, but necessary to match design
                >
                    Go to Media Partner Details
                </a>
            </div>
        </React.Fragment>
    );
};

export default SetVisibleCategoriesInputs;
